
export const colors = ["rgb(105, 179, 162)", "gray", "red", "green"];


export const colors_probability = ["red", "green","gray", "rgb(105, 179, 162)", ];

// "#b2d9cd" lighter teal

// "#b2d9cd" lighter teal